<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Print Label Barcode</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Inventory / Print Label Barcode</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          type="button"
          icon="pi pi-print"
          label="Print"
          class="mr-2"
          :loading="isLoadingPrint"
          @click="generateBarcode()"
        />
        <Button
          type="button"
          icon="pi pi-save"
          label="Save"
          :disabled="active === 0"
          class="p-button-secondary mr-2"
          @click="save()"
        />
        <Button
          type="button"
          icon="pi pi-refresh"
          label="Refresh"
          class="p-button-outlined"
          @click="clearFilter()"
        />
      </div>
      <TabView v-model:activeIndex="active" @tab-change="onTabChange()">
        <TabPanel header="Label Barcode dari Penerimaan">
          <div class="col-12">
            <div class="formgrid grid">
              <div class="field col-12 md:col-2">
                <label>No. Penerimaan</label>
                <AutoComplete
                  v-model="selectedReceive"
                  class="w-full"
                  input-class="w-full"
                  :suggestions="listReceive"
                  field="rcv_no"
                  v-on:clear="true"
                  @complete="searchReceive"
                  @item-select="selectReceive"
                  @keyup.enter="onReceiveEnter"
                >
                  <template #item="slotProps">
                    <div>
                      <b>{{ slotProps.item.rcv_no }}</b>
                    </div>
                    <div>
                      {{ formatDate(slotProps.item.rcv_at) }} |
                      {{ slotProps.item.supplier.name }}
                    </div>
                  </template>
                </AutoComplete>
              </div>
              <div class="field col-12 md:col-3">
                <label> &nbsp; </label>
                <InputText
                  v-model="form.supplier"
                  class="w-full"
                  disabled
                  input-class="w-full"
                />
              </div>
              <div class="field col-12 md:col-4 mt-5">
                <input
                  ref="changeCheckbox"
                  :checked="change"
                  type="checkbox"
                  @click="onChecked"
                  @keyup.enter="onChangeCheckboxEnter"
                /><label>Hanya Item dengan Perubahan Harga</label>
              </div>
              <div class="field col-12 md:col-3 mt-4">
                <Button
                  ref="loadButton"
                  icon="pi pi-sync"
                  label="Load Data Penerimaan"
                  class="mr-2"
                  :disabled="!(form.id > 0)"
                  @click="loadItem"
                />
              </div>
            </div>
          </div>
          <div class="card">
            <fx-table
              :items="items"
              :total="items.length"
              :loading="isLoading"
              :paginator="false"
              hasFooter
              showGridlines
            >
              <template #columns>
                <Column
                  field="rcv_at"
                  header="Tgl. RCV"
                  :showFilterMenu="false"
                  style="min-width: 6rem"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    {{ formatDate(data.rcv_at) }}
                  </template>
                </Column>
                <Column
                  field="description"
                  header="Deskripsi"
                  class="bg-gray"
                  style="min-width: 15rem"
                  header-style="align-items: end"
                />
                <Column
                  field="unit_b"
                  header="Satuan"
                  class="bg-gray"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    {{ data.unit_b }}.{{ data.unit_s }}
                  </template>
                </Column>
                <Column
                  field="ubox"
                  header="Isi"
                  class="bg-gray"
                  style="width: 2rem"
                  header-style="align-items: end"
                />
                <Column
                  field="qty_rcv"
                  header="Qty.&nbsp; RCV"
                  class="bg-gray"
                  style="min-width: 5rem"
                  header-style="align-items: end"
                />
                <Column
                  field="qty_stock"
                  header="Stock Qty"
                  class="bg-gray"
                  style="min-width: 5rem"
                  header-style="align-items: end"
                />
                <Column
                  field="cur_price"
                  header="HRG Jual SKRG"
                  class="bg-gray"
                  style="min-width: 8rem"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    {{ formatCurrency(data.cur_price) }}
                  </template>
                </Column>
                <Column
                  field="new_price"
                  header="HRG Jual Baru"
                  class="bg-gray"
                  style="min-width: 8rem"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    {{ formatCurrency(data.new_price) }}
                  </template>
                </Column>
                <Column
                  field="qty_label"
                  header="Qty. Label"
                  class="bg-gray"
                  style="min-width: 5rem"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    <InputNumber
                      v-model="data.qty_label"
                      type="text"
                      class="w-full"
                      input-class="w-full"
                    />
                  </template>
                </Column>
                <Column
                  field="description_label"
                  header="Keterangan"
                  class="bg-gray"
                  style="min-width: 12rem"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    <InputText
                      v-model="data.description_label"
                      type="text"
                      class="w-full"
                      input-class="w-full"
                      maxlength="20"
                    />
                  </template>
                </Column>
              </template>
            </fx-table>
          </div>
        </TabPanel>
        <TabPanel header="Label Barcode Manual">
          <div class="col-12">
            <div class="formgrid grid">
              <div class="field col-12 md:col-3">
                <label>Item</label>
                <AutoComplete
                  v-model="selectedItem"
                  class="w-full"
                  input-class="w-full"
                  :suggestions="listItems"
                  field="name"
                  @complete="searchItem"
                  @item-select="selectItem"
                  @keyup.enter="onItemEnter"
                >
                  <template #item="slotProps">
                    <div>
                      <b>{{ slotProps.item.sku }}</b>
                    </div>
                    <div>{{ slotProps.item.name }}</div>
                  </template>
                </AutoComplete>
              </div>
              <div class="field col-12 md:col-3">
                <label> Supplier </label>
                <AutoComplete
                  ref="supplier"
                  v-model="selectedSupplier"
                  class="w-full"
                  input-class="w-full"
                  placeholder="Search"
                  :suggestions="listSupplier"
                  field="name"
                  @complete="searchSupplier"
                  @item-select="onSelectSupplier"
                  @keyup.enter="onSupplierEnter"
                >
                </AutoComplete>
              </div>
              <div class="field col-12 md:col-2 mt-4">
                <Button
                  ref="addButton"
                  icon="pi pi-plus"
                  label="Tambah Item"
                  class="w-full"
                  @click="onAddData"
                />
              </div>
              <div class="field col-12 md:col-2 mt-4">
                <Button
                  icon="pi pi-times-circle"
                  label="Clear All"
                  class="p-button-outlined"
                  @click="onReset"
                />
              </div>
            </div>
          </div>
          <div class="card">
            <fx-table
              :items="itemManuals"
              :total="itemManuals.length"
              :loading="isLoading"
              :paginator="false"
              hasFooter
              showGridlines
            >
              <template #columns>
                <Column
                  field="sku"
                  header="Kode"
                  class="bg-gray"
                  style="min-width: 3rem"
                  header-style="align-items: end"
                />
                <Column
                  field="barcode_1"
                  header="Barcode"
                  class="bg-gray"
                  style="min-width: 8rem"
                  header-style="align-items: end"
                />
                <Column
                  field="description"
                  header="Deskripsi"
                  class="bg-gray"
                  style="min-width: 18rem"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    <InputText
                      v-model="data.description"
                      type="text"
                      class="w-full"
                      input-class="w-full"
                      maxlength="20"
                    />
                  </template>
                </Column>
                <Column
                  field="unit"
                  header="Satuan"
                  class="bg-gray"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    {{ data.unit_b }}.{{ data.unit_s }}
                  </template>
                </Column>
                <Column
                  field="ubox"
                  header="Isi"
                  class="bg-gray"
                  style="width: 2rem"
                  header-style="align-items: end"
                />
                <Column
                  field="qty_label"
                  header="Qty. Print"
                  class="bg-gray"
                  style="min-width: 3rem"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    <InputNumber
                      v-model="data.qty_label"
                      type="text"
                      class="w-full"
                      input-class="w-full"
                    />
                  </template>
                </Column>
                <Column
                  field="price"
                  header="Harga"
                  class="bg-gray"
                  style="min-width: 8rem"
                  header-style="align-items: end"
                >
                  <template #body="{ data }">
                    {{ formatCurrency(data.price) }}
                  </template>
                </Column>
                <Column
                  field="supplier"
                  header="Supplier"
                  class="bg-gray"
                  style="min-width: 12rem"
                  header-style="align-items: end"
                >
                </Column>
                <Column style="flex-grow: 1; justify-content: flex-end">
                  <template #body="{ data }">
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      class="p-button-outlined p-button-danger p-button-text"
                      @click="onConfirmDeletion(data)"
                    />
                  </template>
                </Column>
              </template>
            </fx-table>
          </div>
        </TabPanel>
      </TabView>
    </div>
    <Dialog
      header="Hapus Item dari List"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Item <strong>{{ formManual.description }}</strong> akan dihapus dari
          List Item Barcode. Proses ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Hapus"
          icon="pi pi-trash"
          @click="onDeleteItem(this.rowdata)"
          class="p-button-text p-button-danger"
        />
      </template>
    </Dialog>
    <Dialog
      :header="pdfTitle"
      v-model:visible="dialogViewer"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '60vw' }"
      :modal="true"
    >
      <div class="mb-2">
        <small
          >Preview ZPL ({{ zplLabelCount }} label). Pastikan printer Zebra
          default sudah terpasang lewat Zebra Browser Print.</small
        >
      </div>
      <div
        class="mb-3"
        style="
          max-height: 140px;
          overflow-y: auto;
          border: 1px solid #eee;
          border-radius: 4px;
        "
      >
        <table
          class="w-full"
          style="font-size: 12px; border-collapse: collapse"
        >
          <thead style="position: sticky; top: 0; background: #fafafa">
            <tr>
              <th class="text-left p-2" style="border-bottom: 1px solid #eee">
                Barcode
              </th>
              <th class="text-left p-2" style="border-bottom: 1px solid #eee">
                Nama Barang
              </th>
              <th class="text-right p-2" style="border-bottom: 1px solid #eee">
                Qty Cetak
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in zplSummary" :key="idx">
              <td class="p-2">{{ row.barcode }}</td>
              <td class="p-2">{{ row.title }}</td>
              <td class="p-2 text-right font-bold">{{ row.qty }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <small class="text-color-secondary block mb-2"
        >Angka qty di atas diambil langsung dari isian qty label kamu (bukan
        hasil hitung ulang teks ZPL), jadi ini yang jadi acuan jumlah pcs
        yang benar-benar akan tercetak.</small
      > -->
      <div
        class="mb-3"
        style="
          min-height: 210px;
          background: #fafafa;
          border: 1px dashed #ddd;
          border-radius: 4px;
        "
      >
        <div
          v-if="isLoadingPreview"
          class="flex align-items-center justify-content-center"
          style="min-height: 210px"
        >
          <i class="pi pi-spin pi-spinner text-2xl text-color-secondary"></i>
        </div>
        <embed
          v-else-if="zplPreviewPdfUrl"
          :src="zplPreviewPdfUrl"
          type="application/pdf"
          width="100%"
          height="510px"
        />
        <small
          v-else
          class="text-color-secondary p-2 text-center block"
          style="padding-top: 80px"
        >
          Preview PDF tidak tersedia (butuh koneksi internet ke labelary.com).
          Teks ZPL di bawah tetap bisa didownload / dicetak.
        </small>
      </div>
      <!-- <small class="text-color-secondary" v-if="zplPreviewPdfUrl"
        >* 1 halaman = 1 desain label (jumlah pcs dicetak lewat perintah
        printer, bukan diulang di preview).</small
      >
      <Textarea
        v-model="zplContent"
        class="w-full mt-2"
        style="font-family: monospace; font-size: 11px"
        :autoResize="false"
        rows="10"
        readonly
      /> -->
      <template #footer>
        <Button
          type="button"
          label="Download .zpl"
          icon="pi pi-download"
          class="p-button-text mr-2"
          @click="onDownloadZpl"
        />
        <Button
          type="button"
          label="Print ke Zebra"
          icon="pi pi-print"
          :loading="isSendingToPrinter"
          @click="onPrintZpl"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import SupplierService from '@/services/SupplierService'
import BarcodeService from '@/services/BarcodeService'
import errorHandler from '@/helpers/error-handler'
import Hotkey from '@/components/Hotkey'
import { formatCurrency, formatDate } from '@/helpers/index'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'

import FxTable from '@/components/FxTable'
import { useAuthStore } from '@/store/auth'

// import Textarea from 'primevue/textarea'
import { saveAs } from 'file-saver'
import ZebraBrowserPrintWrapper from 'zebra-browser-print-wrapper'
import ItemService from '@/services/ItemService'

// Media ZM400 ini berisi 3 label per baris (sama seperti layout PDF versi
// lama): halaman fisik 109mm x 17mm berisi 3 slot @ 33mm x 15mm dengan
// jarak antar slot 5mm dan margin atas/bawah 1mm.
// ZM400 200dpi Zebra sebenarnya berjalan di 203dpi = 8 dot/mm.
// Kalau printernya 300dpi, ganti DOTS_PER_MM jadi 11.8.
const DOTS_PER_MM = 8
const LABEL_WIDTH_MM = 33
const LABEL_HEIGHT_MM = 15
const COLS_PER_PAGE = 3
const COL_OFFSETS_MM = [2, 38, 75] // kolom pertama digeser 2mm ke kanan
const TOP_MARGIN_MM = 1
const PAGE_WIDTH_MM = 109
const PAGE_HEIGHT_MM = LABEL_HEIGHT_MM + TOP_MARGIN_MM * 2 // 17mm

const LABEL_WIDTH_DOTS = Math.round(LABEL_WIDTH_MM * DOTS_PER_MM)
const LABEL_HEIGHT_DOTS = Math.round(LABEL_HEIGHT_MM * DOTS_PER_MM)
const PAGE_WIDTH_DOTS = Math.round(PAGE_WIDTH_MM * DOTS_PER_MM)
const PAGE_HEIGHT_DOTS = Math.round(PAGE_HEIGHT_MM * DOTS_PER_MM)
const COL_OFFSETS_DOTS = COL_OFFSETS_MM.map((v) => Math.round(v * DOTS_PER_MM))
const TOP_MARGIN_DOTS = Math.round(TOP_MARGIN_MM * DOTS_PER_MM)
const LABEL_BARCODE_X_DOTS = 22
const LABEL_PRICE_X_DOTS = 26
const LABEL_PRICE_BOTTOM_DOTS = 28
const MAX_LABEL_QTY = 1000

const MONTH_CODE = [
  '',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
]

export default {
  name: 'PrintBarcode',
  components: {
    Hotkey,
    TabView,
    TabPanel,
    FxTable,
    // Textarea,
  },
  data() {
    return {
      index: 0,
      rowdata: {},
      isLoading: false,
      isLoadingSave: false,
      isLoadingPrint: false,
      barcodeService: null,
      listReceive: [],
      selectedReceive: null,
      selectedSupplier: null,
      form: {},
      formManual: {},
      items: [],
      itemManuals: [],
      itemService: null,
      supplierService: null,
      listItems: [],
      listSupplier: [],
      submitted: false,
      selectedItem: [],
      listDeleted: [],
      active: 0,
      change: false,
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: '',
        sortOrder: '1',
        filters: null,
      },
      zplContent: '',
      zplFilename: '',
      zplLabelCount: 0,
      zplPreviewPdfUrl: null,
      zplSummary: [], // [{ barcode, title, qty }] dari qty_label langsung, bukan hasil parsing ZPL
      isLoadingPreview: false,
      pdfTitle: 'ZPL Preview ',
      dialogViewer: false,
      dialogHapus: false,
      isSendingToPrinter: false,
      browserPrint: null,
    }
  },
  created() {
    this.supplierService = new SupplierService()
    this.barcodeService = new BarcodeService()
    this.itemService = new ItemService()
    this.browserPrint = new ZebraBrowserPrintWrapper()
  },
  mounted() {
    if ('rcvid' in localStorage) {
      this.change = true
      this.form.id = localStorage.getItem(`rcvid`)
      this.loadItem()
    }

    this.barcodeService
      .get()
      .then((res) => {
        this.itemManuals = res.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Barcode', this)
      })
      .finally(() => (this.isLoading = false))
  },
  methods: {
    onItemEnter() {
      // Tunggu sampai proses selectItem selesai melakukan update DOM
      this.$nextTick(() => {
        const input = this.$refs.supplier?.$el?.querySelector('input')

        if (input) {
          input.focus()

          // Cursor di akhir teks Supplier
          input.setSelectionRange(input.value.length, input.value.length)
        }
      })
    },
    onChangeCheckboxEnter() {
      this.$nextTick(() => {
        const btn = this.$refs.loadButton?.$el
        if (btn) {
          btn.focus()
        }
      })
    },
    generateBarcode() {
      this.isLoadingPrint = true
      setTimeout(() => {
        if (this.active == 0) {
          this.generateBarCodebyRcv()
        } else {
          this.generateBarCodeManual()
        }

        this.isLoadingPrint = false // Reset loading state after the process is done
      }, 100)
      // if (this.active == 0) {
      //   this.generateBarCodebyRcv()
      // } else {
      //   this.generateBarCodeManual()
      // }
    },
    generateBarCodebyRcv() {
      if (this.items.length == 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Barcode',
          detail: 'Pilih dan load data penerimaan terlebih dahulu.',
          life: 3000,
        })
        return
      }

      if (this.isLoadingPrint === true) {
        let itemTotal = 0
        this.items.forEach((item) => {
          itemTotal += item.qty_label
        })
        if (itemTotal > MAX_LABEL_QTY) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Barcode',
            detail:
              'Jumlah label barcode melebihi batas cetak maksimal 1000 pcs',
            life: 3000,
          })
          this.isLoadingPrint = false
          return
        }

        let instances = []
        let summary = []
        this.items.forEach((item) => {
          if (!item.qty_label || item.qty_label < 1) return
          const inst = {
            barcode: item.barcode_1,
            title: item.description_label,
            subtitle: item.barcode_1 + ' - ' + item.supp,
            priceText: this.formatCurrency(item.new_price),
            cornerLines: [item.dcode, MONTH_CODE[item.mcode] || '', item.ycode],
          }
          for (let i = 0; i < Math.round(item.qty_label); i++) {
            instances.push(inst)
          }
          summary.push({
            barcode: item.barcode_1,
            title: item.description_label,
            qty: Math.round(item.qty_label),
          })
        })

        this.zplContent = this.buildZplPages(instances)
        this.zplSummary = summary
        this.zplLabelCount = itemTotal
        this.zplFilename = 'item-barcode-rcv.zpl'
        this.pdfTitle = 'ZPL Preview (' + this.zplFilename + ')'
        this.dialogViewer = true
        this.isLoadingPrint = false
        this.fetchZplPreview()
      }
    },
    generateBarCodeManual() {
      if (this.itemManuals.length == 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Barcode',
          detail: 'Pilih item barcode terlebih dahulu.',
          life: 3000,
        })
        return
      }
      if (this.isLoadingPrint === true) {
        let itemTotal = 0
        this.itemManuals.forEach((item) => {
          itemTotal += item.qty_label
        })
        if (itemTotal > MAX_LABEL_QTY) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Barcode',
            detail:
              'Jumlah label barcode melebihi batas cetak maksimal 1000 pcs',
            life: 3000,
          })
          this.isLoadingPrint = false
          return
        }

        let instances = []
        let summary = []
        this.itemManuals.forEach((item) => {
          if (!item.qty_label || item.qty_label < 1) return
          const inst = {
            barcode: item.barcode_1,
            title: item.description,
            subtitle: item.barcode_1 + ' - ' + item.supp,
            priceText: this.formatCurrency(item.price),
          }
          for (let i = 0; i < Math.round(item.qty_label); i++) {
            instances.push(inst)
          }
          summary.push({
            barcode: item.barcode_1,
            title: item.description,
            qty: Math.round(item.qty_label),
          })
        })

        this.zplContent = this.buildZplPages(instances)
        this.zplSummary = summary
        this.zplLabelCount = itemTotal
        this.zplFilename = 'item-barcode-manual.zpl'
        this.pdfTitle = 'ZPL Preview (' + this.zplFilename + ')'
        this.dialogViewer = true
        this.isLoadingPrint = false
        this.fetchZplPreview()
      }
    },
    selectReceive() {
      this.form.id = this.selectedReceive.id
      this.form.rcv_at = this.selectedReceive.rcv_at
      this.form.rcv_no = this.selectedReceive.rcv_no
      this.form.supplier = this.selectedReceive.supplier.name
    },
    searchReceive(event) {
      this.form = {}
      this.barcodeService
        .receive(event.query)
        .then((res) => {
          this.listReceive = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Receive', this)
        })
        .finally(() => (this.isLoading = false))
    },
    searchSupplier(event) {
      const search = event.query
      this.supplierService
        .getList(search)
        .then((res) => {
          this.listSupplier = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Supplier', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onSelectSupplier() {
      if (this.selectedSupplier) {
        this.form.supp_id = this.selectedSupplier.id
        this.formManual.supplier = this.selectedSupplier.name
        this.formManual.supp = this.selectedSupplier.supp
      }
    },
    formatDate(value) {
      return formatDate(value, false)
    },
    formatCurrency(value) {
      return formatCurrency(value, 0, 0)
    },
    onReset() {
      this.itemManuals.forEach((item) => {
        this.listDeleted.push(item.id)
      })
      this.itemManuals = []
    },
    clearFilter() {
      this.listReceive = []
      this.selectedReceive = null
      this.form = {}
      this.items = []
      this.formManual = {}
      this.selectedItem = null

      this.barcodeService
        .get()
        .then((res) => {
          this.itemManuals = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Barcode', this)
        })
        .finally(() => (this.isLoading = false))
    },
    searchItem(event) {
      this.itemService
        .getList(event.query)
        .then((res) => {
          this.listItems = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Item', this)
        })
        .finally(() => (this.isLoading = false))
    },
    selectItem() {
      this.formManual.id = 0
      this.formManual.item_id = this.selectedItem.id
      this.formManual.sku = this.selectedItem.sku
      this.formManual.barcode_1 = this.selectedItem.barcode_1
      this.formManual.description = this.selectedItem.name.substr(0, 20)
      this.formManual.ubox = this.selectedItem.ubox
      this.formManual.unit_s = this.selectedItem.unit_s
      this.formManual.unit_b = this.selectedItem.unit_b
      this.formManual.supp_id = this.selectedItem.supp_id
      this.formManual.price = this.selectedItem.price
      this.formManual.qty_label = 1

      this.supplierService
        .getById(`/${this.formManual.supp_id}`)
        .then((res) => {
          this.listSupplier = [res.data.data]
          this.selectedSupplier = res.data.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Supplier', this)
        })
    },
    onAddData() {
      if (this.formManual.item_id == null) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Barcode',
          detail: 'Pilih item terlebih dahulu.',
          life: 3000,
        })
        return
      }

      const idx = this.itemManuals.findIndex(
        (item) =>
          item.item_id === this.formManual.item_id &&
          item.supp_id === this.formManual.supp_id
      )
      if (idx !== -1) {
        const item = this.itemManuals[idx]
        this.$toast.add({
          severity: 'warn',
          summary: 'Barcode',
          detail:
            'Item ' +
            item.description +
            ' dengan supplier ' +
            item.supplier +
            ' sudah ada di list.',
          life: 3000,
        })
        return
      }
      const idn = this.listSupplier.findIndex(
        (item) => item.id === this.formManual.supp_id
      )
      if (idn !== -1) {
        const supplier = this.listSupplier[idn]
        this.formManual.supplier = supplier.name
        this.formManual.supp = supplier.supp
      }

      this.itemManuals.push(this.formManual)
      this.formManual = {}
      this.selectedItem = null
      this.selectedSupplier = null
    },
    onConfirmDeletion(data) {
      this.index = data.index
      this.rowdata = data
      this.dialogHapus = true
    },
    onDeleteItem(data) {
      this.listDeleted.push(this.rowdata.id)
      this.itemManuals.splice(data.index, 1)
      // this.$toast.add({
      //   severity: 'success',
      //   summary: 'Data Item Barcode',
      //   detail: 'Data berhasil dihapus.',
      //   life: 3000,
      // })
      this.dialogHapus = false
    },
    save() {
      this.submitted = true
      // const deleted = this.id ? { deleted: this.listDeleted } : { deleted: [] }
      const auth = useAuthStore()
      const form = {
        username: auth.user.name,
        details: this.itemManuals.map((item) => {
          return {
            id: item.id,
            item_id: item.item_id,
            sku: item.sku,
            barcode_1: item.barcode_1,
            description: item.description,
            ubox: item.ubox,
            unit_s: item.unit_s,
            unit_b: item.unit_b,
            supp_id: item.supp_id,
            price: item.price,
            qty_label: item.qty_label,
            supp: item.supp,
            supplier: item.supplier,
          }
        }),
        deleted: this.listDeleted,
      }
      this.isLoadingSave = true
      this.barcodeService
        .save(form)
        .then((res) => {
          if (res.data.status === 1) {
            this.$toast.add({
              severity: 'success',
              summary: 'Barcode Item',
              detail: 'Data berhasil disimpan.',
              life: 3000,
            })
          }
        })
        .catch((err) => {
          errorHandler(err, 'Barcode Item', this)
        })
        .finally(() => {
          this.deleted = []
          this.isLoadingSave = false
        })
    },
    onTabChange() {
      if (this.active === 1) {
        // this.supplierService
        //   .getList()
        //   .then((res) => {
        //     this.listSupplier = res.data
        //   })
        //   .catch((err) => {
        //     errorHandler(err, 'Data Supplier', this)
        //   })
        //   .finally(() => (this.isLoading = false))
      }
    },
    onChecked() {
      this.change = !this.change
    },
    loadItem() {
      this.isLoading = true

      this.barcodeService
        .receiveitem(this.form.id, this.change)
        .then((res) => {
          this.items = res.data
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Receive Item', this)
        })
        .finally(() => (this.isLoading = false))
    },
    // Menghasilkan field ZPL (^FO...^FS) untuk SATU slot label, digeser
    // sejauh xOffset dot ke kanan supaya bisa ditaruh di kolom 1/2/3 dalam
    // satu halaman (^XA...^XZ) berisi 3 label sekaligus, sesuai media
    // roll ZM400 yang 3 kolom.
    buildLabelFields(
      { barcode, title, subtitle, priceText, cornerLines = [] },
      xOffset
    ) {
      const lines = []
      const y = TOP_MARGIN_DOTS

      // Judul / keterangan
      lines.push('^CF0,16')
      lines.push(
        `^FO${xOffset + LABEL_BARCODE_X_DOTS},${y + 3}^FD${this.escapeZpl(
          title
        )}^FS`
      )

      // Barcode CODE39, tanpa human-readable line (sudah ada teks sendiri)
      lines.push('^BY1.3,2,34')
      lines.push(
        `^FO${xOffset + LABEL_BARCODE_X_DOTS},${
          y + 21
        }^B3N,N,34,N,N^FD${this.escapeZpl(barcode)}^FS`
      )

      // Barcode + supplier
      lines.push('^CF0,13')
      lines.push(
        `^FO${xOffset + LABEL_BARCODE_X_DOTS},${y + 61}^FD${this.escapeZpl(
          subtitle
        )}^FS`
      )

      // Kode pojok kanan atas (dcode/mcode/ycode), kalau ada
      if (cornerLines.some((l) => l)) {
        lines.push('^CF0,11')
        cornerLines.forEach((line, idx) => {
          if (!line) return
          lines.push(
            `^FO${xOffset + LABEL_WIDTH_DOTS - 38},${
              y + 3 + idx * 15
            }^FD${this.escapeZpl(line)}^FS`
          )
        })
      }

      // Harga
      lines.push('^CF0,15')
      lines.push(
        `^FO${xOffset + LABEL_PRICE_X_DOTS},${
          y + LABEL_HEIGHT_DOTS - LABEL_PRICE_BOTTOM_DOTS
        }^FD${this.escapeZpl(priceText)}^FS`
      )

      return lines.join('')
    },
    // Susun daftar "instance" label (1 entri = 1 pcs fisik) jadi
    // halaman-halaman berisi maksimal 3 label bersebelahan (COLS_PER_PAGE).
    // Halaman yang isinya identik berturut-turut (biasanya karena qty_label
    // besar untuk 1 item) digabung jadi satu blok ^XA dengan ^PQ, supaya
    // ZPL tidak membengkak walau totalnya ratusan pcs.
    buildZplPages(instances) {
      const pageBodies = []
      for (let i = 0; i < instances.length; i += COLS_PER_PAGE) {
        const slot = instances.slice(i, i + COLS_PER_PAGE)
        const body = slot
          .map((inst, c) => this.buildLabelFields(inst, COL_OFFSETS_DOTS[c]))
          .join('')
        pageBodies.push(body)
      }

      let zpl = ''
      let i = 0
      while (i < pageBodies.length) {
        let count = 1
        while (
          i + count < pageBodies.length &&
          pageBodies[i + count] === pageBodies[i]
        ) {
          count++
        }
        zpl +=
          '^XA' +
          `^PW${PAGE_WIDTH_DOTS}` +
          `^LL${PAGE_HEIGHT_DOTS}` +
          '^LH0,0' +
          '^MD15' + // Tambah darkness 15 dari setting printer (default 15 -> efektif 30)
          '^CI28' + // UTF-8, biar karakter Indonesia aman
          pageBodies[i] +
          `^PQ${count},0,1,Y` +
          '^XZ\n'
        i += count
      }
      return zpl
    },
    // Escape ^ dan ~ karena keduanya adalah prefix command ZPL (^) dan
    // control command (~). Kalau muncul di data (mis. deskripsi barang),
    // printer akan salah membaca dan label jadi rusak/pecah.
    escapeZpl(value) {
      return String(value ?? '')
        .replace(/\^/g, '')
        .replace(/~/g, '')
        .substring(0, 30)
    },
    // Render seluruh ZPL jadi satu PDF (1 halaman = 1 desain label) lewat
    // labelary.com (API publik gratis yang mengerti ZPL) -- persis seperti
    // preview PDF di versi lama, cuma sumbernya sekarang ZPL bukan jsPDF.
    // Ini butuh internet dan mengirim isi label ke server pihak ketiga;
    // kalau gagal/diblokir, teks ZPL di bawah tetap bisa dipakai.
    async fetchZplPreview() {
      if (this.zplPreviewPdfUrl) {
        URL.revokeObjectURL(this.zplPreviewPdfUrl)
      }
      this.zplPreviewPdfUrl = null
      if (!this.zplContent) return

      this.isLoadingPreview = true
      try {
        const widthIn = (PAGE_WIDTH_MM / 25.4).toFixed(2)
        const heightIn = (PAGE_HEIGHT_MM / 25.4).toFixed(2)
        // Tanpa index di URL -> Labelary mengembalikan SEMUA label,
        // satu halaman PDF per label (^PQ tidak ikut menggandakan halaman).
        const res = await fetch(
          `https://api.labelary.com/v1/printers/${DOTS_PER_MM}dpmm/labels/${widthIn}x${heightIn}/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Accept: 'application/pdf',
            },
            body: this.zplContent,
          }
        )
        if (!res.ok) throw new Error('Labelary responded ' + res.status)
        const blob = await res.blob()
        this.zplPreviewPdfUrl = URL.createObjectURL(blob) + '#toolbar=0'
      } catch (err) {
        this.zplPreviewPdfUrl = null
        // eslint-disable-next-line no-console
        console.warn('Gagal memuat preview PDF ZPL:', err)
      } finally {
        this.isLoadingPreview = false
      }
    },
    onDownloadZpl() {
      const blob = new Blob([this.zplContent], {
        type: 'text/plain;charset=utf-8',
      })
      saveAs(blob, this.zplFilename)
    },
    async onPrintZpl() {
      if (!this.zplContent) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Barcode',
          detail: 'Tidak ada data ZPL untuk dicetak.',
          life: 3000,
        })
        return
      }

      this.isSendingToPrinter = true
      try {
        const defaultPrinter = await this.browserPrint.getDefaultPrinter()
        this.browserPrint.setPrinter(defaultPrinter)

        const status = await this.browserPrint.checkPrinterStatus()
        if (!status.isReadyToPrint) {
          this.$toast.add({
            severity: 'error',
            summary: 'Printer Zebra',
            detail: status.errors || 'Printer tidak siap.',
            life: 4000,
          })
          return
        }

        await this.browserPrint.print(this.zplContent)
        this.$toast.add({
          severity: 'success',
          summary: 'Printer Zebra',
          detail: 'Label berhasil dikirim ke printer.',
          life: 3000,
        })
        this.dialogViewer = false
      } catch (err) {
        this.$toast.add({
          severity: 'error',
          summary: 'Printer Zebra',
          detail:
            'Gagal menghubungi Zebra Browser Print. Pastikan aplikasi Zebra Browser Print sedang berjalan di komputer ini.',
          life: 5000,
        })
        // eslint-disable-next-line no-console
        console.error(err)
      } finally {
        this.isSendingToPrinter = false
      }
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        //
      }
    },
    onLoadingPrint() {
      setTimeout(() => {
        this.isLoadingPrint = true
      }, 500)
    },
  },
}
</script>
